import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Home from './views/Home.vue'
import Login from './views/Login.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      //meta: {
      //  guest: true
      //}
    },
    {
      path: '/artists',
      name: 'artists',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "artists" */ './views/Artists.vue')
    },
    {
      path: '/artist/add',
      name: 'artist_add',
      props: true,
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "artist" */ './views/Artist.vue')
    },
    {
      path: '/artist/:id',
      name: 'artist',
      props: true,
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "artist" */ './views/Artist.vue')
    },
    {
      path: '/fanzone/:id/artist/:id',
      name: 'artist',
      props: true,
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "artist" */ './views/Artist.vue')
    },
    {
      path: '/fanzones',
      name: 'fanzones',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "fanzone" */ './views/Fanzones.vue')
    },
    {
      path: '/fanzones-places',
      name: 'fanzones-places',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "fanzone" */ './views/Fanzones-places.vue')
    },
    {
      path: '/fanzone/add',
      name: 'fanzone_add',
      props: true,
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "fanzone" */ './views/Fanzone.vue')
    },
    {
      path: '/fanzone/:id',
      name: 'fanzone',
      props: true,
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "fanzone" */ './views/Fanzone.vue')
    },
    {
      path: '/fanzone-places/:id',
      name: 'fanzone-places',
      props: true,
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "fanzone" */ './views/Fanzone-places.vue')
    },
    {
      path: '/fanzones-urban-actions',
      name: 'fanzones-urban-actions',
      props: true,
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "fanzone" */ './views/Fanzones-urban-actions.vue')
    },
    {
      path: '/fanzone-urban-action/:id',
      name: 'fanzone-urban-action',
      props: true,
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "fanzone" */ './views/Fanzone-urban-action.vue')
    },
    {
      path: '/fanzones-roadtours',
      name: 'fanzones-roadtours',
      props: true,
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "fanzone" */ './views/Fanzones-roadtours.vue')
    },
    {
      path: '/fanzone-roadtour/:id',
      name: 'fanzone-roadtour',
      props: true,
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "fanzone" */ './views/Fanzone-roadtour.vue')
    },
  ]
})


router.beforeEach((to, from, next) => {
  //var requiresAuth = to.matched.some( record => record.meta.requiresAuth )
  if (to.path != '/login' && !store.getters.isLoggedIn) {
    next({
      name: 'login'
    });
  } else if (to.path == '/login' && store.getters.isLoggedIn) {
    next({
      name: 'home'
    });
  } else {
    next();
  }
})

export default router